<template>
	<Base class="mb-1">
		<template>
			<ListTransaction
				:showPagination="false"
				:showPaginationFooter="true"
			/>
		</template>
	</Base>
</template>

<script>
	import Base from "@/templates/Base.vue";
	import ListTransaction from "@/components/Transactions/ListTransaction.vue";

	export default {
		components: {
			Base,
			ListTransaction
		}
	};
</script>
